module.exports = __webpack_public_path__ + "static/img/u-connect-reg-section-2-backgroud.2da5b14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/u-connect-reg-section-2-backgroud.png
// module id = +LqJ
// module chunks = 1